// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UDjU","question":"styles_question__2OuK2","inputVisibleButton":"styles_inputVisibleButton__1r4dz","note":"styles_note__2jnFQ"};